import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Formik } from "formik";
import * as Yup from "yup";
import BeatLoader from "react-spinners/BeatLoader";
import { toast } from "react-toastify";
import { portalLogin } from "../../services/merchant-portal";
import { setOtpChallenge } from "../../utils/merchant-portal-storage";
import "./portal.scss";

const schema = Yup.object({
  identifier: Yup.string().trim().required("Email or phone is required"),
  pin: Yup.string()
    .matches(/^[0-9]{5}$/, "PIN must be exactly 5 digits")
    .required("PIN is required"),
});

const MerchantPortalLogin = () => {
  const navigate = useNavigate();
  const [formError, setFormError] = useState("");

  return (
    <div className="portal-auth-page bg-main-bg dark:bg-main-dark-bg">
      <div className="portal-card portal-auth-card">
        <h1 className="text-xl font-semibold mb-1">Merchant sign in</h1>
        <p className="portal-muted mb-6">
          Use your merchant email or phone and 5-digit PIN. We will send a
          WhatsApp OTP to verify.
        </p>
        {formError ? (
          <div className="text-red-500 text-sm mb-4">{formError}</div>
        ) : null}
        <Formik
          initialValues={{ identifier: "", pin: "" }}
          validationSchema={schema}
          onSubmit={async (values, { setSubmitting }) => {
            setFormError("");
            try {
              const res = await portalLogin(
                values.identifier.trim(),
                values.pin,
              );
              if (res.status_code === 200 && res.data?.challenge_id) {
                setOtpChallenge(res.data.challenge_id, res.data.masked_phone);
                toast.success(res.message || "OTP sent");
                navigate("/merchant-portal/verify-otp");
              } else {
                setFormError(res.message || "Login failed");
              }
            } catch (err) {
              setFormError(`${err}`);
            } finally {
              setSubmitting(false);
            }
          }}
        >
          {({
            handleSubmit,
            handleChange,
            values,
            errors,
            touched,
            isSubmitting,
          }) => (
            <form onSubmit={handleSubmit} className="portal-form">
              <div className="field">
                <label htmlFor="identifier">Email or phone</label>
                <input
                  id="identifier"
                  name="identifier"
                  value={values.identifier}
                  onChange={handleChange}
                  autoComplete="username"
                />
                {errors.identifier && touched.identifier ? (
                  <div className="error">{errors.identifier}</div>
                ) : null}
              </div>
              <div className="field">
                <label htmlFor="pin">PIN</label>
                <input
                  id="pin"
                  name="pin"
                  type="password"
                  inputMode="numeric"
                  maxLength={5}
                  value={values.pin}
                  onChange={handleChange}
                  autoComplete="current-password"
                />
                {errors.pin && touched.pin ? (
                  <div className="error">{errors.pin}</div>
                ) : null}
              </div>
              <button
                type="submit"
                className="portal-btn w-full mt-2"
                disabled={isSubmitting}
              >
                {isSubmitting ? <BeatLoader size={8} color="#fff" /> : "Continue"}
              </button>
            </form>
          )}
        </Formik>
        <p className="portal-muted mt-6 text-center">
          Admin user?{" "}
          <Link to="/login" className="text-[#03C9D7]">
            Back to admin login
          </Link>
        </p>
      </div>
    </div>
  );
};

export default MerchantPortalLogin;
